import React from 'react';
import { Outlet } from 'react-router-dom';

const Premium = () => {


    return (
        <div>
            <Outlet></Outlet>
        </div>
    );
};

export default Premium;